import React from "react";
import { resolveMediaUrl, handleMediaImgError } from "../Helper/mediaUrl";

/**
 * Shared Community feed media renderer — images, GIFs, and uploaded video
 * use one responsive frame so sizing matches YouTube/Vimeo embeds.
 */
function MediaFrame({ children }) {
  return <div className="community-post__media-frame">{children}</div>;
}

function MediaImage({ src, alt = "" }) {
  if (!src) return null;
  return (
    <MediaFrame>
      <img src={src} alt={alt} loading="lazy" onError={handleMediaImgError} />
    </MediaFrame>
  );
}

function MediaVideo({ src }) {
  if (!src) return null;
  return (
    <MediaFrame>
      <video src={src} controls playsInline preload="metadata" />
    </MediaFrame>
  );
}

export default function CommunityPostMedia({ item }) {
  if (!item) return null;

  const attachments =
    item.attachments && item.attachments.length ? item.attachments : null;
  const images =
    !attachments && item.images && item.images.length ? item.images : null;
  const hasLegacyMedia = !!(
    !attachments &&
    item.media &&
    item.media.path
  );
  const hasLegacyVideo = !!(
    !attachments &&
    item.video &&
    item.video.path &&
    !(item.media && item.media.type === "video")
  );

  if (!attachments && !images && !hasLegacyMedia && !hasLegacyVideo) {
    return null;
  }

  const isGallery =
    (attachments && attachments.length > 1) ||
    (images && images.length > 1);

  return (
    <div
      className={
        "community-post__media" +
        (isGallery ? " community-post__media--gallery" : "")
      }
    >
      {attachments
        ? attachments.map((att, idx) => {
            const src = resolveMediaUrl(att.external_url || att.path || "");
            if (att.type === "video") {
              return <MediaVideo key={att.id || `att-${idx}`} src={src} />;
            }
            return <MediaImage key={att.id || `att-${idx}`} src={src} />;
          })
        : null}

      {!attachments &&
      item.media &&
      item.media.path &&
      item.media.type === "video" ? (
        <MediaVideo src={resolveMediaUrl(item.media.path)} />
      ) : null}

      {!attachments &&
      item.media &&
      item.media.path &&
      item.media.type !== "video" ? (
        <MediaImage
          src={resolveMediaUrl(item.media.external_url || item.media.path)}
        />
      ) : null}

      {!attachments &&
        (images || []).map((img, idx) => (
          <MediaImage
            key={`img-${idx}`}
            src={resolveMediaUrl(img.external_url || img.path || img)}
          />
        ))}

      {!attachments && hasLegacyVideo ? (
        <MediaVideo src={resolveMediaUrl(item.video.path)} />
      ) : null}
    </div>
  );
}
